import {QRCodeSVG} from 'qrcode.react'
import React from 'react'

import * as classes from './QRCodeSvg.classes'

type Props = {
  text: string
  vertical?: boolean
}

const QRCODE_SIZE = 200
const LARGE_QRCODE_SIZE = 286

const QRCodeSvg: React.FC<Props> = props => {
  const {text, vertical} = props

  return (
    <div className={classes.qrcodeContainer}>
      <QRCodeSVG size={vertical ? LARGE_QRCODE_SIZE : QRCODE_SIZE} value={text} />
    </div>
  )
}

QRCodeSvg.displayName = 'QRCodeSvg'

export {QRCodeSvg}
